import * as React from "react";
import { forwardRef } from "react";
const SvgGroupResize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 24 24", fill: "none", stroke: "#9DC1FB", strokeWidth: 2, strokeLinecap: "round", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 21, y1: 15, x2: 15, y2: 21 }), /* @__PURE__ */ React.createElement("line", { x1: 21, y1: 10, x2: 10, y2: 21 }), /* @__PURE__ */ React.createElement("line", { x1: 21, y1: 5, x2: 5, y2: 21 }));
const ForwardRef = forwardRef(SvgGroupResize);
export { ForwardRef as ReactComponent };
